import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import { IconButton, Link, Toolbar } from "@mui/material";
import { LanguageItem } from "./types";

const HeaderMobileMenu = ({
  pageLanguages,
  onClick,
  onHomeIconClick,
}: {
  pageLanguages: any[];
  onClick: (item: LanguageItem) => void;
  onHomeIconClick: () => void;
}) => (
  <Toolbar
    role="presentation"
    sx={{
      flexDirection: "column",
      alignItems: "flex-start",
      zIndex: "20",
      position: "absolute",
      left: "0",
      right: "0",
    }}
  >
    {pageLanguages?.map((item: any) => (
      <Link
        key={item.languageName}
        color="common.white"
        fontSize="0.75rem"
        fontWeight="600"
        href={item?.isDefault ? undefined : ""}
        underline={item?.isDefault ? "none" : "hover"}
        sx={{
          fontWeight: "normal",
          textDecoration: "none",
          fontSize: "1rem",
          padding: "12px 16px",
        }}
        onClick={(e) => {
          e.preventDefault();
          onClick(item);
        }}
      >
        {item.languageName}
      </Link>
    ))}
    <IconButton
      color="inherit"
      edge="start"
      onClick={() => {
        onHomeIconClick();
      }}
      sx={{ padding: "10px 12px", margin: 0 }}
    >
      <HomeOutlinedIcon />
    </IconButton>
  </Toolbar>
);

export default HeaderMobileMenu;
